export type CustomerAttribute = {
  name: string;
  value: string;
  entityId: number;
} | null;

export interface Customer {
  entityId: number;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  customerGroupId: number;
  notes: string;
  phone: string;
  addressCount: number;
  attributeCount: number;
  attributes: {
    d365CustomerId: CustomerAttribute;
    emailFrequency: CustomerAttribute;
    emailGear: CustomerAttribute;
    emailClearance: CustomerAttribute;
    emailEvents: CustomerAttribute;
    emailReviews: CustomerAttribute;
    emailFeedback: CustomerAttribute;
    loyaltyStatus: CustomerAttribute;
    preferredLanguage: CustomerAttribute;
    emailConsent: CustomerAttribute;
    memberNumber: CustomerAttribute;
    authenticationOneTimeToken?: {
      name?: string;
      value?: string;
      entityId?: number;
    } | null;
    notAuthenticated: CustomerAttribute;
  };
}

// Customer group configuration object that reads from environment variables, fallback are current prod values
export const CustomerGroups = {
  Guest: parseInt(process.env.NEXT_PUBLIC_BIGCOMMERCE_GUEST_GROUP_ID || '10'),
  Member: parseInt(process.env.NEXT_PUBLIC_BIGCOMMERCE_MEMBER_GROUP_ID || '1'),
  Employee: parseInt(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_EMPLOYEE_GROUP_ID || '2'
  ),
  Family: parseInt(process.env.NEXT_PUBLIC_BIGCOMMERCE_FAMILY_GROUP_ID || '3'),
  Honorary: parseInt(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_HONORARY_GROUP_ID || '4'
  ),
  ACMG: parseInt(process.env.NEXT_PUBLIC_BIGCOMMERCE_ACMG_GROUP_ID || '9'),
  CAFFR: parseInt(process.env.NEXT_PUBLIC_BIGCOMMERCE_CAFFR_GROUP_ID || '8'),
  Ambassadors: parseInt(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_AMBASSADORS_GROUP_ID || '6'
  ),
  Employee20Year: parseInt(
    process.env.NEXT_PUBLIC_BIGCOMMERCE_EMPLOYEE_20YEAR_GROUP_ID || '7'
  ),
} as const;

export type CustomerGroupId =
  (typeof CustomerGroups)[keyof typeof CustomerGroups];
